import { FileText, Mic2, Projector, ScrollText, Users } from "lucide-react";
// TODO link base url to env
import { SETTINGS } from "@/utils/settings";
export const DOCS_CONFIG = {
  beta: {
    label: "Beta",
    meta: {
      baseUrl: SETTINGS.API_ENDPOINT,
      auth: "loopp-token: <token>",
      contentType: "application/json",
    },
    endpoints: {
      meetings: {
        id: "meetings",
        url: "meetings",
        label: "Meets",
        icon: Projector,
        description: "Create, retrieve, and manage meeting records by date, doc ID, or short code.",
        endpoints: [
          {
            id: "get-meets-today",
            title: "Get Meets — Today",
            description: "Fetch all meetings scheduled for today for the authenticated user.",
            method: "POST",
            path: "/meets/get",
            curl: `curl -X POST '<BASE_URL>/meets/get' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"st": "BY-TODAY", "sk": "current"}'`,
          },
          {
            id: "get-meets-upcoming",
            title: "Get Meets — Upcoming",
            description: "Fetch all upcoming meetings for the authenticated user.",
            method: "POST",
            path: "/meets/get",
            curl: `curl -X POST '<BASE_URL>/meets/get' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"st": "BY-UPCOMING", "sk": "current"}'`,
          },
          {
            id: "get-meets-past",
            title: "Get Meets — Past",
            description: "Fetch all past meetings for the authenticated user.",
            method: "POST",
            path: "/meets/get",
            curl: `curl -X POST '<BASE_URL>/meets/get' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"st": "BY-PAST", "sk": "current"}'`,
          },
          {
            id: "get-meet-by-doc-id",
            title: "Get Meet by Doc ID",
            description: "Fetch a single meeting record by its document ID.",
            method: "POST",
            path: "/meets/get",
            curl: `curl -X POST '<BASE_URL>/meets/get' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"st": "DOC-ID", "sk": "<MEETS_ID>"}'`,
          },
          {
            id: "get-meet-by-short-code",
            title: "Get Meet by Short Code",
            description: "Fetch a single meeting record by its short code.",
            method: "POST",
            path: "/meets/get",
            curl: `curl -X POST '<BASE_URL>/meets/get' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"st": "SHORT-CODE", "sk": "<SHORT_CODE>"}'`,
          },
          {
            id: "create-meet",
            title: "Create Meet",
            description: "Create a new meeting with full details.",
            method: "POST",
            path: "/meets/create",
            curl: `curl -X POST '<BASE_URL>/meets/create' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"title": "<TITLE>", "start_time": "<ISO_DATE>", "end_time": "<ISO_DATE>", "members": ["<MEMBER_ID>", "<MEMBER_ID>"]}'`,
          },
          {
            id: "create-meet-quick",
            title: "Create Quick Meet",
            description: "Quickly create a meeting with just a title and time range.",
            method: "POST",
            path: "/meets/create/quick",
            curl: `curl -X POST '<BASE_URL>/meets/create/quick' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"title": "<TITLE>", "start_time": "<ISO_DATE>", "end_time": "<ISO_DATE>", "members": ["<MEMBER_ID>", "<MEMBER_ID>"]}}'`,
          },
          {
            id: "update-meet",
            title: "Update Meet",
            description: "Update the details of an existing meeting.",
            method: "POST",
            path: "/meets/update",
            curl: `curl -X POST '<BASE_URL>/meets/update' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"sk": "<MEETS_ID>", "title": "<NEW_TITLE>"}'`,
          },
          {
            id: "set-start-time",
            title: "Set Start Time",
            description: "Mark a meeting as started by setting its start timestamp.",
            method: "GET",
            path: "/meets/set-start-time/:meets_id",
            curl: `curl -X GET '<BASE_URL>/meets/set-start-time/<MEETS_ID>' \\\n  -H 'TOKEN: <your-auth-token>'`,
          },
        ],
      },

      meets_summary: {
        id: "meets_summary",
        url: "meets-summaries",
        label: "Meets Summary",
        icon: ScrollText,
        description: "Retrieve AI-generated summaries for meetings by doc ID or meeting ID.",
        endpoints: [
          {
            id: "get-summary-by-doc-id",
            title: "Get Summary by Doc ID",
            description: "Fetch the AI-generated summary for a meeting by its document ID.",
            method: "POST",
            path: "/meets-summary/get",
            curl: `curl -X POST '<BASE_URL>/meets-summary/get' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"st": "DOC-ID", "sk": "<MEETS_ID>"}'`,
          },
          {
            id: "get-summary-by-meets-id",
            title: "Get Summary by Meets ID",
            description: "Fetch the AI-generated summary associated with a given meeting.",
            method: "POST",
            path: "/meets-summary/get",
            curl: `curl -X POST '<BASE_URL>/meets-summary/get' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"st": "BY-MEETS-ID", "sk": "<MEETS_ID>"}'`,
          },
        ],
      },

      meets_detailed: {
        id: "meets_detailed",
        label: "Meets Detailed",
        url: "meets-details",
        icon: FileText,
        description: "Access full transcription records and speaker-level detail for a meeting.",
        endpoints: [
          {
            id: "get-detailed-by-doc-id",
            title: "Get Detailed by Doc ID",
            description: "Fetch the full transcription record for a meeting by its document ID.",
            method: "POST",
            path: "/meets-detailed/get",
            curl: `curl -X POST '<BASE_URL>/meets-detailed/get' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"st": "DOC-ID", "sk": "<MEETS_ID>"}'`,
          },
          {
            id: "get-detailed-by-meets-id",
            title: "Get Detailed by Meets ID",
            description: "Fetch the full transcription record associated with a given meeting.",
            method: "POST",
            path: "/meets-detailed/get",
            curl: `curl -X POST '<BASE_URL>/meets-detailed/get' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"st": "BY-MEETS-ID", "sk": "<MEETS_ID>"}'`,
          },
        ],
      },

      users: {
        id: "users",
        label: "Users",
        url: "users",
        icon: Users,
        description: "Create, retrieve, update, and manage users and their connections.",
        endpoints: [
          {
            id: "create-user",
            title: "Create User",
            description: "Create a new user record.",
            method: "POST",
            path: "/users/create",
            curl: `curl -X POST '<BASE_URL>/users/create' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"first_name": "<FIRST>", "last_name": "<LAST>", "email": "<EMAIL>"}'`,
          },
          {
            id: "get-users",
            title: "Get Users",
            description: "Retrieve users filtered by search type, key, and optional value.",
            method: "POST",
            path: "/users/get",
            curl: `curl -X POST '<BASE_URL>/users/get' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"st": "<SEARCH_TYPE>", "sk": "<SEARCH_KEY>", "sv": null}'`,
          },
          {
            id: "get-user-by-doc-id",
            title: "Get User by Doc ID",
            description: "Fetch a single user record by their document ID.",
            method: "POST",
            path: "/users/get",
            curl: `curl -X POST '<BASE_URL>/users/get' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"st": "DOC-ID", "sk": "<USER_ID>", "sv": null}'`,
          },
          {
            id: "get-user-members",
            title: "Get All Members",
            description: "Retrieve all member-type users.",
            method: "POST",
            path: "/users/get/members",
            curl: `curl -X POST '<BASE_URL>/users/get/members' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{}'`,
          },
          {
            id: "get-my-connections",
            title: "Get My Connections",
            description: "Retrieve all connections for the authenticated user.",
            method: "POST",
            path: "/users/get",
            curl: `curl -X POST '<BASE_URL>/users/get' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"st": "MY-CONNECTIONS"}'`,
          },
          {
            id: "update-user",
            title: "Update User",
            description: "Update an existing user record.",
            method: "POST",
            path: "/users/update",
            curl: `curl -X POST '<BASE_URL>/users/update' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"sk": "<USER_ID>", "first_name": "<NEW_NAME>"}'`,
          },
          {
            id: "delete-user",
            title: "Delete User",
            description: "Remove a user record.",
            method: "POST",
            path: "/users/remove",
            curl: `curl -X POST '<BASE_URL>/users/remove' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"sk": "<USER_ID>"}'`,
          },
          {
            id: "remove-connection",
            title: "Remove Connection",
            description: "Remove a connection between the authenticated user and another user.",
            method: "POST",
            path: "/users/connections/remove",
            curl: `curl -X POST '<BASE_URL>/users/connections/remove' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"connection_id": "<USER_ID>"}'`,
          },
        ],
      },

      audio: {
        id: "audio",
        url: "audio",
        label: "Audio",
        icon: Mic2,
        description: "Upload audio chunks, finalise recordings, and stream or download merged audio files.",
        endpoints: [
          {
            id: "upload-section",
            title: "Upload Audio Section",
            description: "Upload an individual audio chunk for a meeting. Accepts WAV, WebM, OGG, MP4, M4A.",
            method: "POST",
            path: "/audio/api/upload-section",
            curl: `curl -X POST '<BASE_URL>/audio/api/upload-section' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -F 'file=@<FILE_PATH>' \\\n  -F 'meeting_id=<MEETS_ID>' \\\n  -F 'date_time=<ISO_DATE>'`,
          },
          {
            id: "complete-recording",
            title: "Complete Recording",
            description: "Finalise a recording — merges all uploaded sections and triggers transcription.",
            method: "POST",
            path: "/audio/api/complete-recording",
            curl: `curl -X POST '<BASE_URL>/audio/api/complete-recording' \\\n  -H 'Content-Type: application/json' \\\n  -H 'TOKEN: <your-auth-token>' \\\n  -d '{"short_code": "<SHORT_CODE>"}'`,
          },
          {
            id: "stream-audio",
            title: "Stream Audio",
            description: "Stream the merged audio file for a meeting. Supports HTTP range requests.",
            method: "GET",
            path: "/audio/api/stream/:meeting_id",
            curl: `curl -X GET '<BASE_URL>/audio/api/stream/<MEETS_ID>' \\\n  -H 'Range: bytes=0-'`,
          },
          {
            id: "download-audio",
            title: "Download Audio",
            description: "Generate a pre-signed download URL (1hr expiry) for the merged audio file.",
            method: "GET",
            path: "/audio/api/download-section/:meeting_id",
            curl: `curl -X GET '<BASE_URL>/audio/api/download-section/<MEETS_ID>' \\\n  -H 'TOKEN: <your-auth-token>'`,
          },
        ],
      },
    },
  },
  '0.5': {
    label: "v0.5",
    meta: {
      baseUrl: SETTINGS.API_ENDPOINT,
      auth: "loopp-token: <token>",
      contentType: "application/json",
    },
    endpoints: {}
  },
};


// export const getDocsSectionConfig = (section) => DOCS_CONFIG["beta"]["endpoints"][section];
// export const getDocsVersionMeta = () => DOCS_CONFIG["beta"]["meta"];

const DEFAULT_VERSION = "beta";

export const getDocsVersionsList = () =>
  Object.entries(DOCS_CONFIG).map(([key, cfg]) => ({ key, label: cfg.label }));

export const getDocsSectionConfig = (section, version = DEFAULT_VERSION) =>
  DOCS_CONFIG[version]?.endpoints?.[section];

export const getDocsSectionsArr = (version = DEFAULT_VERSION) =>
  Object.values(DOCS_CONFIG[version]?.endpoints ?? {});

export const getDocsVersionMeta = (version = DEFAULT_VERSION) =>
  DOCS_CONFIG[version]?.meta;



export const DOCS_SECTIONS_ARR = getDocsSectionsArr()
